import React from 'react';
import { Check, X } from 'lucide-react';
const rows = [['Dudas en salidas y mano a mano', 'Decisiones rápidas y precisas'], ['Goles evitables por mala ubicación', 'Posicionamiento perfecto por ángulos'], ['Inseguridad para ordenar la defensa', 'Liderazgo y comunicación efectiva'], ['Entrenamientos sin foco', 'Rutinas específicas para entrenar sola'], ['Frustración tras los errores', 'Fortaleza mental ante la adversidad'], ['Falta de recursos modernos', 'Dominio total de la técnica actual']];
export function ComparisonTable() {
  return <div className="w-full max-w-3xl mx-auto my-8 overflow-hidden rounded-2xl shadow-md border border-green-100 bg-white" data-id="element-26">
      {/* Headers */}
      <div className="grid grid-cols-2" data-id="element-27">
        <div className="bg-red-50 py-3 px-3 text-center font-black text-red-700 text-sm md:text-base border-b border-r border-green-100" data-id="element-28">
          Sin Arquera 360
        </div>
        <div className="bg-green-100 py-3 px-3 text-center font-black text-green-800 text-sm md:text-base border-b border-green-200" data-id="element-29">
          Con Arquera 360
        </div>
      </div>

      {/* Rows */}
      {rows.map(([without, withIt], i) => <div key={i} className={`grid grid-cols-2 ${i % 2 === 0 ? 'bg-white' : 'bg-green-50/40'}`} data-id="element-30">
          <div className="flex items-start gap-2 py-2.5 px-3 text-red-900 text-xs md:text-sm border-r border-green-100 leading-snug" data-id="element-31">
            <X className="w-4 h-4 text-red-400 flex-shrink-0 mt-0.5" data-id="element-32" />
            <span data-id="element-33">{without}</span>
          </div>
          <div className="flex items-start gap-2 py-2.5 px-3 text-green-900 font-semibold text-xs md:text-sm leading-snug" data-id="element-34">
            <Check className="w-4 h-4 text-green-600 flex-shrink-0 mt-0.5" data-id="element-35" />
            <span data-id="element-36">{withIt}</span>
          </div>
        </div>)}
    </div>;
}